import PropTypes from 'prop-types';
import {pathOr} from 'ramda';
import {useCallback, useContext, useMemo} from 'react';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import PopupContext from '../../../popup/utils/PopupContext';
import {Button, CheckboxCommon, PageTitle, Separator, Text} from '../../../ui';
import css from '../styles/ContentCreatorSignature.module.css';
import ChangeSignaturePopup from './ChangeSignaturePopup';
import ConfirmRemovingSignaturePopup from './ConfirmRemovingSignaturePopup';

const ContentCreatorSignature = ({userData}) => {
  const isSignatureExist = useMemo(
    () => pathOr(false, ['has_signature'], userData),
    [userData.has_signature]
  );

  const {openPopup} = useContext(PopupContext);

  const handleOpenSignatureEditClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <ChangeSignaturePopup />,
      options: {withCloseButton: true},
    });
  }, []);

  const handleOpenPopupRemoveSignature = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <ConfirmRemovingSignaturePopup />,
      options: {withCloseButton: true},
    });
  }, []);

  return (
    <section>
      <PageTitle title={<TextLocal id={'profile.add-your-signature'} />} />
      <div className={css.main}>
        <div className={css.leftSide}>
          <div className={css.aboutSignature}>
            <Text
              fontSize={Text.FONT_SIZE.SIZE_18}
              fontWeight={Text.FONT_WEIGHT.MEDIUM}
            >
              <TextLocal
                id={'signature.create-signature-for-all-certificate'}
              />
            </Text>
          </div>
          {isSignatureExist && (
            <div
              className={css.profileCheckbox}
              onClick={handleOpenPopupRemoveSignature}
            >
              <CheckboxCommon
                checked
                label={
                  <div>
                    <Text
                      fontSize={Text.FONT_SIZE.SIZE_14}
                      color={Text.COLOR.GREY}
                      lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_4}
                    >
                      <TextLocal
                        id={'signature.confirm-profile-settings-checkbox'}
                      />
                    </Text>
                  </div>
                }
              />
            </div>
          )}
        </div>

        <div className={css.rightSide}>
          <Button
            color={Button.COLOR.SECONDARY}
            border={Button.BORDER.BOLD}
            height={Button.HEIGHT.SMALL}
            onClick={handleOpenSignatureEditClick}
          >
            <TextLocal
              id={isSignatureExist ? 'signature.change' : 'signature.add'}
            />
          </Button>
        </div>
      </div>
      <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
    </section>
  );
};

ContentCreatorSignature.propTypes = {
  userData: PropTypes.object.isRequired,
};

export default ContentCreatorSignature;
